const bg = {
  time_zone: 'Времева зона',
  chart: 'Графика',

  //Timeframes every
  every: 'Всяка',
  granularity: 'Грануларност',
  second: 'секунда',
  seconds: 'секунди',
  seconds_short: 'с',
  minute: 'минутa',
  minutes: 'минути',
  minute_short: 'м',
  hour: 'час',
  hours: 'часа',
  hour_short: 'ч',
  day: 'ден',
  days: 'дни',
  no_auto_refresh_short: 'Няма',

  // chrono units
  nanos: 'Наносекунди',
  micros: 'Микросекунди',
  millis: 'Милисекунди',
  half_days: 'Половин дни',
  weeks: 'Седмици',
  months: 'Месеци',
  years: 'Години',
  decades: 'Десетилетия',
  centuries: 'Векове',
  millennia: 'Хилядолетия',
  eras: 'Епохи',
  forever: 'Завинаги',

  //Status
  on: 'Включено',
  off: 'Изключено',
  auto: 'Автоматично',

  //common
  sensor_index: 'Индекс на сензора',
  slave_device_number: 'Номер на подчиненото устройство',
  select: 'Изберете',
  create: 'Създайте',
  update: 'Актуализирайте',
  relay_index: 'Индекс на релето',
  devices: 'Устройства',
  device_name: 'Име на устройство',
  device_number: 'Номер на устройство',

  //command status
  pending: 'Изчакване',
  sent: 'Изпратено',
  cancelled: 'Отменено',
  status_ok: 'Ок',
  status_nok: 'Не е Ок',
  timeout: 'Времето изтече',
  unknown: 'Неизвестно',

  //Text
  text_add: 'Добави',
  text_edit: 'Редактирай',
  no_data_for_selected_period: 'Няма данни за посочения период',
  choose_location: 'Изберете населено място',
  more_information: 'Повече информация',
  track_device: 'Проследяване на устройство',
  not_found: 'Не е намерено',
  powered_by: 'Поддържа се от ',

  // Solution types
  solution_none: 'Незададен',
  solution_agri: 'Аграрен',
  solution_air_quality: 'Чистота на въздуха',
  solution_street_lights: 'Улично осветление',
  solution_pump_station: 'Помпена станция',
  solution_smart_waste: 'Умни отпадъци',
  solution_level: 'Мониторинг на ниво',
  solution_gas: 'Мониторинг на газ',
  solution_pressure: 'Мониторинг на налягане',
  solution_smart_water: 'Умна вода',
  solution_energy: 'Мониторинг на енергия',
  solution_environment_monitoring: 'Мониторинг на околната среда',

  //Control buttons
  add_button: 'Добави',
  edit_button: 'Редактирай',
  save_button: 'Запази',
  cancel_button: 'Отмени',
  clear_button: 'Изчисти',
  language_button: 'Eзик',
  logout_button: 'Изход',
  change_info_for_field: 'Промени данни за поле',
  on_button: 'Вкл.',
  off_button: 'Изкл.',
  auto_button: 'Авто',
  toggle_button: 'Превключи',
  door_open_sensor_text: 'Отв.',
  door_closed_sensor_text: 'Затв.',
  no_auto_refresh: 'Без автоматично обновяване',
  refresh_now: 'Обнови сега',

  //Drawer form fields
  drawer_field_information_text: 'Информация за полето',
  drawer_devices_config: 'Конфигурация на устройства',
  drawer_layer_name: 'Име на слой',
  drawer_status: 'Статус',
  drawer_region_name: 'Област',
  drawer_description: 'Описание',
  drawer_layer_size: 'Размер на слоя',
  drawer_previous_culture: 'Предишна култура',
  drawer_device: 'Устройство',
  drawer_sensor: 'Сензор',

  //Menu
  menu_home: 'Начало',
  menu_calendar: 'Календар',
  menu_journal: 'Дневник',
  menu_alarms: 'Аларми',
  menu_old_home: 'Начало (старо)',
  menu_streetlight: 'Улично Осветление',
  menu_trashbags: 'Събирания по чували',
  menu_collections: 'Събирания по партиди',
  menu_truck_collections: 'Събирания по камиони',
  menu_truck_collections_by_container: 'Събирания по камиони по съдове',
  menu_container_collections: 'Събирания по съдове',
  menu_reports: 'Справки',

  //Map banner text
  map_banner_select: 'Избери поле',
  map_banner_create: 'Създай поле',
  map_cluster_devices_header: 'Устройства ({{deviceCount}})',

  //Field information
  field_info_view: 'Преглед',
  field_info_alarms: 'Аларми:',
  field_info_header: 'Информация за полето',
  field_info_status: 'СТАТУС',
  field_info_region: 'ОБЛАСТ',
  field_info_description: 'Описание:',
  field_info_area: 'ПЛОЩ',
  field_info_previous_culture: 'ПРЕДИШНА КУЛТУРА',
  field_info_linked_devices: 'Свързани устройства:',
  field_info_distance_traveled: 'Изминато разстояние',

  //Forecast widget
  forecast_today: 'Днес',
  forecast_three_days: '3 дена',
  forecast_five_days: '5 дена',
  forecast_seven_days: '7 дена',
  forecast_min_temp: 'МАКС ТЕМП',
  forecast_max_temp: 'МИН ТЕМП',
  forecast_cloud_cover: 'ОБЛАЧНОСТ',
  forecast_rain: 'ДЪЖДОВНОСТ',
  forecast_wind: 'ВЯТЪР',
  forecast_wind_direction: 'ПОСОКА НА ВЯТЪР',
  forecast_humidity: 'ВЛАЖНОСТ НА ВЪЗДУХА',

  //Rain Widget
  rain_widget_header: 'Дъждовност',

  //Humidity Widget
  humidity_widget_text: 'Влажност',

  //Soil Moisture Widget
  soil_moisture_widget_text: 'Влажност на почвата',

  //Control Widget
  control_widget_header: 'Контрол',
  relay_control_get_relay_statuses: 'Вземи статусите на релетата',
  poll_linked_devices: 'Запитване свързани устройства',

  //Sensor information widget
  sensor_reference_values_label: 'Референтни стойности',
  sensor_board_label: 'ТАБЛО',
  sensor_all_info_header: 'Сензори',
  sensor_info_header: 'Информация за сензор',
  sensor_info_name: 'Име',
  sensor_info_device: 'Устройство',
  sensor_info_type: 'Тип',
  sensor_info_status: 'Статус',
  sensor_info_max: 'Макс',
  sensor_info_min: 'Мин',
  sensor_info_avg: 'Ср',
  sensor_info_current: 'Текущо',
  sensor_info_counters: 'Брой отчети',
  sensor_info_start_button: 'ПУСНИ',
  sensor_info_stop_button: 'СПРИ',
  sensor_last_refresh: 'Обновено: {{time}}',
  sensor_info_board: 'TАБЛО',
  sensor_info_manufacturer: 'Производител',
  sensor_info_model: 'Модел',
  sensor_info_serial_number: 'Сериен номер',
  sensor_info_diameter: 'Диаметър',

  //Street lights information widget
  power_usage: 'ЕЛЕКТРОКОНСУМАЦИЯ',
  lighting: 'ОСВЕТЛЕНИЕ',
  lights_on: 'Включено',
  lights_off: 'Изключено',
  door_open: 'Отворено',
  door_closed: 'Затворено',

  //Pump station information
  pump1: 'Помпа 1',
  pump2: 'Помпа 2',

  //Device Information
  device_information_name: 'Име',
  device_information_number: 'Номер',
  device_information_model: 'Модел',
  device_information_latitude: 'Г.ш.',
  device_information_longitude: 'Г.д.',
  //Widget detailed button
  widget_detailed_button: 'Подробно',

  //Back To Map Button
  back_to_map_btn: 'Към картата',

  //Wind widget
  wind_widget_header: 'Вятър',

  //Dashboard
  boiler_condition_information: 'Информация за работно състояние на котел',
  street_light_information: 'Информация за улично осветление',
  pump_station_information: 'Информация за помпена станция',
  default_information_panel: 'Информация за устройство',
  dashboard_header: 'Информационен борд за поле:',
  dashboard_chart_value: 'Стойност',
  select_sensor_message: 'Изберете сензор',

  //OnOffAutoLoader
  await_command_execution: 'Моля изчакайте изпълнение на командата',
  command_successful: 'Командата е изпълнена',
  command_unsuccessful: 'Грешка при изпълнение на командата',
  command_error: 'Kомандата не е изпълнена',
  loading: 'Зарежда се',

  //Alarms
  alarms_page_header: 'Аларми',
  alarms_page_device_header: 'Аларми за устройство {{deviceNumber}}',

  alarms_table_date_header: 'Дата',
  alarms_table_device_number_header: 'Номер на устройство',
  alarms_table_type_header: 'Тип',
  alarms_table_description_header: 'Описание',
  alarms_table_sensor_name: 'Име на сензора',

  alarms_none_message: 'Няма намерени аларми за избрания период',
  alarms_control_panel_select_date_message: 'Изберете дата',
  alarms_control_panel_from_date: 'От дата',
  alarms_control_panel_to_date: 'До дата',
  alarms_control_panel_alarm_type: 'Тип аларма',
  alarms_control_panel_alarm_status: 'Статус на Аларма',
  alarms_control_panel_by_device_number: 'Търсене по номер на устройство',
  alarms_control_panel_header: 'Филтри за аларми',

  // Value ranges
  value_ranges_light_rain: 'Слаб дъжд',
  value_ranges_moderate_rain: 'Умерен дъжд',
  value_ranges_heavy_rain: 'Силен дъжд',
  value_ranges_violent_rain: 'Много силен дъжд',
  value_ranges_calm_wind: 'Щил',
  value_ranges_light_air: 'Тих вятър',
  value_ranges_light_breeze: 'Лек бриз',
  value_ranges_gentle_breeze: 'Слаб вятър',
  value_ranges_moderate_breeze: 'Умерен вятър',
  value_ranges_fresh_breeze: 'Полусилен вятър',
  value_ranges_strong_breeze: 'Силен вятър',
  value_ranges_high_wind: 'Доста силен вятър',
  value_ranges_gale: 'Много силен вятър',
  value_ranges_severe_gale: 'Щорм',
  value_ranges_storm: 'Силен щорм',
  value_ranges_violent_storm: 'Много силен щорм',
  value_ranges_hurricane: 'Ураган',
  value_ranges_north_1: 'Север',
  value_ranges_north_notheast: 'Север-Североизток',
  value_ranges_notheast: 'Североизток',
  value_ranges_east_notheast: 'Изток-Североизток',
  value_ranges_east: 'Изток',
  value_ranges_east_southeast: 'Изток-Югоизток',
  value_ranges_southeast: 'Югоизток',
  value_ranges_south_south_east: 'Югоизток',
  value_ranges_south: 'Юг',
  value_ranges_south_southwest: 'Юг-Югозапад',
  value_ranges_southwest: 'Югозапад',
  value_ranges_west_southwest: 'Запад-Югозапад',
  value_ranges_west: 'Запад',
  value_ranges_west_northwest: 'Запад-Северозапад',
  value_ranges_northwest: 'Северозапад',
  value_ranges_north_northwest: 'Север-Северозапад',
  value_ranges_north_2: 'Север',
  value_ranges_dry: 'Сухо',
  value_ranges_normal: 'Нормално',
  value_ranges_wet: 'Мокро',
  value_ranges_frost_point: 'Точка на замръзване',
  value_ranges_frost_point_danger: 'Опасност от замръзване',
  value_ranges_dew_point: 'Точка на оросяване',

  // Data Table Widget
  data_table_widget_header: 'Данни',
  data_table_measurements: 'Измервания',
  data_table_alarms: 'Аларми',
  data_table_widget_from_date: 'От Дата',
  data_table_widget_to_date: 'До Дата',
  data_table_date: 'Дата',
  data_table_value: 'Стойност',
  data_table_range: 'Диапазон',
  flow: 'Поток',
  raw_readings: 'Сурови Данни',
  y_axis_include_zero: 'Включи 0 по оста Y',
  chart_options: 'Опции на графиката',

  //sensors types
  rain_sensor: 'Сензор за дъжд',
  level_sensor: 'Сензор за ниво',
  wind_speed_sensor: 'Сензор за сила на вятър',
  wind_direction_sensor: 'Сензор за посока на вятър',
  water_meter: 'Сензор за водопотребление',
  pressure_sensor: 'Сензор за налягане',
  humidity_sensor: 'Сензор за влажност',
  temperature_sensor: 'Сензор за температура',
  gas_flow_meter: 'Сензор за поток на газ',
  heat_meter: 'Сензор за топлина',
  barometric_pressure_sensor: 'Сензор за атмосферно налягане',
  soil_moisture_sensor: 'Сензор за влага на почвата',
  on_off_sensor: 'Сензор реле',
  on_off_input_sensor: 'Сензор реле',
  on_off_output_sensor: 'Сензор реле',
  generic_analog_sensor: '--',
  power_meter: 'Сензор за електроконсумация',
  soil_temperature_sensor: 'Сензор за температура на почвата',
  dew_point_sensor: 'Сензор за точка на оросяване',
  particulate_matter_sensor: 'Сензор за прахови частици',
  geiger_mueller_counter: 'Сензор за радиация',
  soil_potential_sensor: 'Сензор за воден потенциал на почвата',
  weight_sensor: 'Сензор за тежест',

  sensor: {
    rain: {
      name: 'Количество Валежи',
      valueRanges: {
        no_rain: {
          abbrv: 'Без дъжд ',
          description: 'Когато количеството на дъжд е < 0.1 мм на час',
        },
        light_rain: {
          abbrv: 'Слаб дъжд ',
          description: 'Когато количеството на дъжд е между 0.1 мм и 2.5 мм на час',
        },
        moderate_rain: {
          abbrv: 'Умерен дъжд',
          description: 'Когато количеството на дъжд е между 2.5 мм и 7.6 мм  на час',
        },
        heavy_rain: {
          abbrv: 'Силен дъжд',
          description: 'Когато количеството на дъжд е между 7.6 мм и 50 мм на час',
        },
        violent_rain: {
          abbrv: 'Жесток дъжд',
          description: 'Когато количеството на дъжд е > 50 мм на час',
        },
      },
    },
    windDirection: {
      name: 'Посока на вятъра',
      valueRanges: {
        north_1: {
          abbrv: 'С',
          description: 'Север (349° - 011°)',
        },
        north_2: {
          abbrv: 'С',
          description: 'Север (349° - 011°)',
        },
        north_northeast: {
          abbrv: 'ССИ',
          description: 'Север-Североизток (012°-033°)',
        },
        northeast: {
          abbrv: 'СИ',
          description: 'Североизток (034°-056°)',
        },
        east_northeast: {
          abbrv: 'ИСИ',
          description: 'Изток-Североизток (056°-079°)',
        },
        east: {
          abbrv: 'И',
          description: 'Изток (079°-101°)',
        },
        east_southeast: {
          abbrv: 'ИЮИ',
          description: 'Изток-Югоизток (102°-123°)',
        },
        southeast: {
          abbrv: 'ЮИ',
          description: 'Югоизток (124°-146°)',
        },
        south_southeast: {
          abbrv: 'ИЮИ',
          description: 'Изток-Югоизток (147°-168°)',
        },
        south_southwest: {
          abbrv: 'ЮЮИ',
          description: 'Юг-Югоизток (192°-213°)',
        },
        south: {
          abbrv: 'Ю',
          description: 'Юг (169°-191°)',
        },
        southwest: {
          abbrv: 'ЮЗ',
          description: 'Югозапад (214°-236°)',
        },
        west_southwest: {
          abbrv: 'ЗЮЗ',
          description: 'Запад-Югозапад (237°-258°)',
        },
        west: {
          abbrv: 'И',
          description: 'Изток (259°-281°)',
        },
        west_northwest: {
          abbrv: 'ИСИ',
          description: 'Изток-Североизток (282°-303°)',
        },
        northwest: {
          abbrv: 'СЗ',
          description: 'Северозапад (304°-326°)',
        },
        north_northwest: {
          abbrv: 'ССЗ',
          description: 'Север-Северозапад (327°-348°)',
        },
      },
    },
    windSpeed: {
      name: 'Скорост на Вятър',
      valueRanges: {
        no_wind: {
          abbrv: 'Без вятър',
          description: '(0м/с - 0.1м/с)',
        },
        calm_wind: {
          abbrv: 'Щил',
          description: '(0.1м/с - 1м/с)',
        },
        light_air: {
          abbrv: 'Тих вятър',
          description: ' (2м/с - 3м/с)',
        },
        light_breeze: {
          abbrv: 'Лек бриз',
          description: ' (4м/с - 6м/с)',
        },
        gentle_breeze: {
          abbrv: 'Слаб вятър',
          description: ' (7м/с - 10м/с)',
        },
        moderate_breeze: {
          abbrv: 'Умерен вятър',
          description: ' (11м/с - 16м/с)',
        },
        fresh_breeze: {
          abbrv: 'Полусилен вятър',
          description: '(17м/с - 21м/с)',
        },
        strong_breeze: {
          abbrv: 'Силен вятър',
          description: ' (22м/с - 27м/с)',
        },
        high_wind: {
          abbrv: 'Доста силен вятър',
          description: ' (28м/с - 33м/с)',
        },
        gale: {
          abbrv: 'Много силен вятър',
          description: ' (34м/с - 40м/с)',
        },
        severe_gale: {
          abbrv: 'Щорм',
          description: ' (41м/с - 47м/с)',
        },
        storm: {
          abbrv: 'Силен щорм',
          description: ' (48м/с - 55м/с)',
        },
        violent_storm: {
          abbrv: 'Много силен щорм',
          description: ' (56м/с - 63м/с)',
        },
        hurricane: {
          abbrv: 'Ураган',
          description: ' (64м/с - 77м/с)',
        },
      },
    },
    soil_temperature: {
      valueRanges: {
        idealMin: {
          abbrv: 'Идеално',
          description: 'Идеални условия минимум < 18.3°C',
        },
        idealMax: {
          abbrv: 'Идеално',
          description: 'Идеални условия максимум (между 18.4°C и 30°C)',
        },
        warm: {
          abbrv: 'Топло',
          description: 'Забавен растеж (между 30.1°C и 32.2°C)',
        },
        hot: {
          abbrv: 'Горещо',
          description: 'Не ефикасен растеж (между 32.3°C и 45°C)',
        },
        dangerous: {
          abbrv: 'Опасно',
          description: 'Бактерии умират, губене на влага > 45.1°C',
        },
      },
    },
    soilmoisture: {
      valueRanges: {
        dry: {
          abbrv: 'Сухо',
          description: 'Опасно ниска влага на почвата( < 80%)',
        },
        normal: {
          abbrv: 'Нормално',
          description: 'Нужно е напояване (между 80% и 90%)',
        },
        wet: {
          abbrv: 'Мокро',
          description: 'Не е нужно напояване(между 90% и 100%)',
        },
      },
    },
    dew_point_sensor: {
      valueRanges: {
        frost_point: {
          abbrv: 'Слана',
          description: 'Точката на оросяване е под 1 C.',
        },
        frost_point_danger: {
          abbrv: 'Опасност от слана',
          description: 'Точката на оросяване е под  5 C.',
        },
        dew_point: {
          abbrv: 'Точка на оросяване',
          description: 'Точката на оросяване е над 5 C.',
        },
      },
    },
    gammaRadiation: {
      valueRanges: {
        normal: {
          abbrv: 'Нормално',
        },
        abnormal: {
          abbrv: 'Високо',
        },
        dangerous: {
          abbrv: 'Опасно високо',
        },
      },
    },
    moisture: {
      valueRanges: {
        dry: {
          abbrv: 'Сухо',
        },
        normal: {
          abbrv: 'Нормално',
        },
        wet: {
          abbrv: 'Влажно',
        },
      },
    },
    temperature: {
      valueRanges: {
        cool: {
          abbrv: 'Много студено',
        },
        ideal: {
          abbrv: 'Студенo',
        },
        warm: {
          abbrv: 'Идеално',
        },
        hot: {
          abbrv: 'Горещо',
        },
        dangerous: {
          abbrv: 'Много горещо',
        },
      },
    },
    airMicroGrams: {
      valueRanges: {
        good: {
          abbrv: 'Ниско',
        },
        moderate: {
          abbrv: 'Средно',
        },
        minimal: {
          abbrv: 'Средно',
        },
        sensitive: {
          abbrv: 'Чувствително',
        },
        discomfort: {
          abbrv: 'Чувствително',
        },
        unhealthy: {
          abbrv: 'Вредно',
        },
        veryUnhealthy: {
          abbrv: 'Много вредно',
        },
        hazardous: {
          abbrv: 'Опасно вредно',
        },
        respiratoryIllness: {
          abbrv: 'Опасно (дихателни заболявания)',
        },
        healthImpact: {
          abbrv: 'Опасно за здравето',
        },
      },
    },
    barometricPressure: {
      valueRanges: {
        low: {
          abbrv: 'Ниско',
          description: 'Атмосферно налягане по-малко от 850.',
        },
        normal: {
          abbrv: 'Нормално',
          description: 'Атмосферно налягане повече от 850 и по-малко от 1500',
        },
        high: {
          abbrv: 'Високо',
          description: 'Атмосферно налягане повече от 1500 и по-малко от 3000',
        },
      },
    },
    load_cells: {
      valueRanges: {
        low: {
          abbrv: 'Нормално',
          description: 'Товарът е под 999 kN.',
        },
        normal: {
          abbrv: 'Предупреждение',
          description: 'Товарът е между 1000 и 1100 kN',
        },
        high: {
          abbrv: 'Аларма',
          description: 'Товарът е над 1100 kN',
        },
      },
    },
  },

  //GEOMAN MAP LIBRARY CUSTOM TRANSLATE
  // --tooltips--
  placeMarker: 'Кликни за да поставиш маркер',
  firstVertex: 'Кликни за да поставиш първия вектор',
  continueLine: 'Кликни за да продължиш да чертаеш',
  finishLine: 'Кликни някой от маркерите, за да приключиш',
  finishPoly: 'Кликни първия маркер, за да приключиш',
  finishRect: 'Кликни, за да приключиш',
  startCircle: 'Кликни, за да поставиш кръга на центъра',
  finishCircle: 'Кликни, за да завършиш кръга',
  placeCircleMarker: 'Кликни, за да поставиш маркер на кръга',
  placeText: 'Кликни, за да поставиш текст',

  // -- actions --
  finish: 'Приключи',
  cancel: 'Отмени',
  removeLastVertex: 'Премахни последния вектор',

  // -- button titles --
  drawMarkerButton: 'Постави маркер',
  drawPolyButton: 'Начертай полигон',
  drawLineButton: 'Начертай поли-линия',
  drawCircleButton: 'Начертай кръг',
  drawRectButton: 'Начертай правоъгълник',
  editButton: 'Промени слой',
  dragButton: 'Премести слой',
  cutButton: 'Отрежи слой',
  deleteButton: 'Премахни слой',
  drawCircleMarkerButton: 'Начертай маркер на кръг',
  snappingButton: 'Закачи преместения маркер към друг слой или вектор',
  pinningButton: 'Съедини вектори',
  rotateButton: 'Завърти слой',
  drawTextButton: 'Изпиши текст',

  //CONFIRMATION DIALOG WINDOW
  confirmMessage: 'Сигурни ли сте ,че искате да изтриете избрания (полигон или слой)?',
  confirmAgreeButton: 'Потвърди',
  confirmDisagreeButton: 'Откажи',

  //Journal
  journal_page_header: 'Дневник',

  //Calendar"
  calendar_page_header: 'Календар',

  //Period-Selector
  period_label: 'Период',
  route_date_selector: 'Дата на маршрут',

  period_date_range_option: 'Обхват от-до',
  period_custom_option: 'Персонализиран',
  period_today_option: 'Днес',
  period_week_option: 'Седмичен',
  period_month_option: 'Месечен',
  period_last_h_option: 'Последният час',
  period_last_2_h_option: 'Последните 2 часа',
  period_last_4_h_option: 'Последните 4 часа',
  period_last_24_h_option: 'Последните 24 часа',
  period_last_48_h_option: 'Последните 48 часа',

  //YAMBOL HEADER
  municipality_yambol: 'Община Ямбол',

  //Devices List
  search_placeholder: 'Търси по име на устройство',

  //Error-handling
  toast_server_error_message: 'Възникна проблем с някоя от заявките към сървъра',
  toast_alarms_error_message: 'Възникна проблем с алармите',
  toast_map_error_message: 'Възникна проблем с картата',
  toast_dashboard_error_message: 'Възникна проблем с таблото',
  toast_devices_error_message: 'Възникна проблем със зареждането на устройствата',
  toast_device_config_error_message:
    'Възникна проблем със зареждането на конфигурацията за устройство: {{deviceNumber}}',
  toast_device_current_values_error_message:
    'Възникна проблем с извеждането на отчетените стойности за устройство: {{deviceNumber}}',
  toast_devices_location_error_message:
    'Възникна проблем със зареждането на локацията на устройствата',
  toast_map_setting_per_name_error_message:
    'Възникна проблем със зареждане на настройките на вашата карта',
  toast_map_settings_error_message: 'Възникна проблем с взимането на всички настройки за картите',
  toast_get_user_error_message: 'Възникна проблем със зареждането вашият потребител',
  toast_set_user_language_error_message: 'Възникна проблем със задаването на език',

  //CurrentValuesBox
  current_values_box_info_description: 'Няма информация',
  current_values_box_reference_values: 'Референтни стойности',
  device_info_panel_loading_values: 'Зареждане на текущи стойности',
  device_info_panel_no_values: 'Няма налични текущи стойности',
  device_info_panel_values_error: 'Неуспешно зареждане на текущите стойности',

  /*
   * |=================|
   * | Alarms Export |
   * |=================|
   */

  // Buttons and dropdowns
  alarms_export_header: 'Аларми',
  alarms_export_header_with_device: `Аларми за: {{device_number}}`,
  alarms_export_search: 'Търси',
  alarms_export_download: 'Изтегли',
  alarms_export_format: 'Формат',

  // Table columns
  alarms_export_table_date: 'Дата',
  alarms_export_table_device_number: 'Номер на устройство',
  alarms_export_table_device_name: 'Име на устройство',
  alarms_export_table_severity: 'Значимост',
  alarm_severity_tooltip: 'Значимост: {{value}} от 10',
  alarm_severity_none_tooltip: 'Няма отчетена значимост за тази аларма',
  alarms_export_table_sensor_index: 'Сензор индекс',
  alarms_export_table_sensor_name: 'Сензор име',
  alarms_export_table_alarm_type: 'Тип',
  alarm_type_on_off_alarm: 'Вкл/Изкл аларма',
  alarm_type_no_zero_consumption: 'Без нулева консумация',
  alarm_type_all_zero_consumption: 'Нулева консумация',
  alarm_type_low_flow: 'Нисък поток',
  alarm_type_high_flow: 'Висок поток',
  alarm_type_high_consumption: 'Висока консумация',
  alarm_type_missed_transmission: 'Пропуснато предаване',
  alarm_type_device_removed: 'Премахнато устройство',
  alarm_type_low_level: 'Ниско ниво',
  alarm_type_high_level: 'Високо ниво',
  alarm_type_tamper: 'Тампер',
  alarm_type_oversized: 'Твърде голям',
  alarm_type_undersized: 'Твърде малък',
  alarm_type_low_battery: 'Изтощена батерия',
  alarm_type_blockage: 'Блокирано',
  alarm_type_burst: 'Спукано',
  alarm_type_reverse_flow: 'Обратен поток',
  alarm_type_range_event: 'Излизане от диапазон',
  alarm_type_very_low_level: 'Много ниско ниво',
  alarm_type_very_high_level: 'Много високо ниво',
  alarm_type_leakage: 'Теч',
  alarm_type_low_temperature: 'Ниска температура',
  alarm_type_no_consumption: 'Без консумация',
  alarm_type_negative_flow: 'Отрицателен поток',
  alarm_type_empty_spool: 'Празна тръба',
  alarm_type_combination_of_alarms: 'Комбинация от аларми',
  alarm_type_standstill: 'Без движение',
  alarm_type_reset_error: 'Грешка при рестарт',
  alarm_type_rf_error: 'RF грешка',
  alarm_type_cs_error: 'CS грешка',
  alarm_type_measuring_error: 'Грешка при измерване',
  alarm_type_reset_event: 'Рестарт',
  alarm_type_magnetic_field: 'Магнитно поле',
  alarm_type_sensor_fraud: 'Манипулация на сензора',
  alarms_export_table_alarm_status: 'Статус',
  alarms_export_table_description: 'Описание',
  alarms_export_chip_status_active: 'Активен',
  alarms_export_chip_status_inactive: 'Неактивен',
  alarms_export_switch_title_label: 'Автоматично опресняване',
  alarms_export_error_alert_message: 'Възникна грешка при извличане на данните',
  alarms_export_error_too_big_query:
    'Извличането на хронология от Супер администратор за всички устройства е твърде голяма заявка. Моля, изберете компания.',

  /*
   * |=================|
   * | Task Scheduler  |
   * |=================|
   */

  task_scheduler_link_label: 'Задачи',
  task_scheduler_title: 'График на задачите',
  task_scheduler_remove: 'Премахване',
  task_scheduler_remove_confirmation: 'Сигурни ли сте, че искате да премахнете задачата?',
  task_scheduler_confirm: 'Потвърди',
  task_scheduler_cancel: 'Отказ',
  task_scheduler_remove_successful: 'Задачата е премахната успешно',
  task_scheduler_remove_active: 'Активната задача не може да бъде премахната',
  task_scheduler_edit: 'Редактиране',

  // Form
  task_scheduler_form_name: 'Име на задачата',
  task_scheduler_form_from_date: 'От дата',
  task_scheduler_form_to_date: 'До дата',
  task_scheduler_form_repeat: 'Повтаряй',
  task_scheduler_form_period: 'Интервал',
  task_scheduler_form_temporal: 'Повтаряемост',
  task_scheduler_form_execution_hour: 'Час на изпълнение',
  task_scheduler_form_execution_minute: 'Минута на изпълнение',

  // Toast messages
  task_scheduler_form_create_message: 'Събитието е добавено успешно',
  task_scheduler_form_update_message: 'Събитието е актуализирано успешно',
  task_scheduler_form_create_error_message: 'Възникна грешка при създаването на задачата',
  task_scheduler_form_update_error_message: 'Възникна грешка при актуализацията на задачата',
  task_scheduler_form_delete_message: 'Задачата е премахната успешно',

  // Task execution
  task_execution_error_loading_message: 'Грешка при зареждане на задачите',

  // Tasks list
  scheduled_tasks_list_event_name: 'Име на задачата',
  scheduled_tasks_list_start_date: 'Начална дата',
  scheduled_tasks_list_end_date: 'Крайна дата',
  scheduled_tasks_list_execution_time: 'Време на изпълнение',
  scheduled_tasks_list_last_execution: 'Последно изпълнение',
  scheduled_tasks_list_is_active: 'Активност',
  scheduled_tasks_event_logs_btn_text: 'История на изпълненията',
  scheduled_tasks_view_btn_text: 'Преглед',

  // History table
  scheduled_event_history_title: 'История на задачите',
  scheduled_tasks_history_date_of_execution_header: 'Дата на изпълнение',
  scheduled_tasks_history_status_header: 'Статус на изпълнение',
  scheduled_tasks_history_overview_btn_text: 'Преглед',
  scheduled_tasks_history_task_status_done: 'Завършено',
  scheduled_tasks_history_task_status_pending: 'В очакване',
  scheduled_tasks_history_task_status_failed: 'Неуспешно',
  scheduled_tasks_history_task_status_done_with_errors: 'Завършено с грешки',

  // Task Overview
  task_scheduler_command_task_overview: 'Преглед на задачите',
  task_overview_scheduled_event_name: 'Име на планирано събитие',
  task_overview_desired_state: 'Желано състояние',
  task_overview_command_state: 'Състояние на командата',

  //Event form
  scheduled_task_event_form_required_state: 'Желано състояние',
  scheduled_task_event_form_required_states: 'Желани състояния',
  scheduled_task_event_form_scheduled_event: 'Планирана задача',
  scheduled_task_event_form_new_scheduled_event: 'Направи нова планирана задача',
  scheduled_task_event_form_edit_scheduled_event: 'Редактиране на планирана задача',
  scheduled_task_event_form_event_type: 'Тип на задача',
  scheduled_task_event_form_start_date: 'Начална дата',
  scheduled_task_event_form_end_date: 'Крайна дата',
  scheduled_task_event_form_last_execution: 'Последно изпълнение',
  scheduled_task_event_form_execution_time: 'Време за изпълнение',
  scheduled_task_event_form_relay_state: 'Състояние на релето',
  scheduled_task_event_form_select: 'Изберете',
  scheduled_task_event_form_hour: 'Час на изпълнение на устройството',
  scheduled_task_event_form_minute: 'Минута на изпълнение на устройството',
  scheduled_task_event_form_modbus_command_type: 'Тип команда',
  scheduled_task_event_form_modbus_command_type_read_coil_1: 'Вземи състояние на релето',
  scheduled_task_event_form_modbus_command_type_read_register_3: 'Вземи стойност',
  scheduled_task_event_form_modbus_command_type_write_coil_5: 'Изпрати команда',

  // Scheduled task event types
  command_type_single_relay_switch: 'Единичен релеен превключвател',
  command_type_relay_switch: 'Релеен превключвател',
  command_type_auto_relay_switch: 'Автоматичен релеен превключвател',
  command_type_send_date_over_mqtt: 'Изпращане на дата през MQTT',
  command_type_modbus: 'Modbus',
  command_type_tasmota_power: 'Tasmota Power',
  command_type_scheduled_relay_command: 'Планирана команда за реле',
  command_type_scheduled_relay_command_4: 'Планирани команди за реле (4)',
  command: 'Команда',

  // Error handling
  scheduled_tasks_could_not_find_event_with_id:
    'Не може да бъде намерена задача с ID: {{event_id}}',
  scheduled_tasks_could_not_get_event_logs_for_event: 'Възникна проблем с историята на задачата',
  scheduled_tasks_could_not_update_event_with_id:
    'Не може да бъде актуализирана задача с ID: {{event_id}}',
  logo_error_message: 'Не можа да се зареди логото на компанията',

  //resolvers
  scheduled_tasks_event_name_min_length: 'Името на събитието трябва да съдържа поне 3 символа',
  scheduled_tasks_event_name_max_length: 'Името на събитието трябва да бъде под 50 символа',
  scheduled_tasks_from_date_invalid: 'Началната дата трябва да бъде след днес',
  scheduled_tasks_to_date_invalid: 'Крайната дата трябва да бъде след началната дата',
  scheduled_tasks_execution_hour_range: 'Часът на изпълнение трябва да бъде между 0 и 23',
  scheduled_tasks_execution_minute_range: 'Минути на изпълнение трябва да бъдат между 0 и 59',
  scheduled_tasks_period_required: 'Периодът трябва да бъде положително цяло число',
  scheduled_tasks_temporal_required: 'Временната стойност е задължителна',
  scheduled_tasks_event_device_numbers_length:
    'Всеки номер на устройство трябва да бъде точно 8 символа',
  scheduled_tasks_event_sensor_index_range:
    'Индексът на сензора трябва да бъде положително цяло число или 0',
  scheduled_tasks_event_relay_states_required:
    'Състоянията на релето трябва да бъдат посочени за типа RELAY_SWITCH',
  scheduled_tasks_event_required_state_auto_relay:
    'Необходимо е да се посочи състояние за типа AUTO_RELAY_SWITCH',
  scheduled_tasks_event_required_state_tasmota_power:
    'Необходимо е да се посочи състояние за типа TASMOTA_POWER',
  scheduled_tasks_event_slave_device_number_length:
    'Номерът на слейв устройството трябва да бъде точно 8 символа',
  scheduled_tasks_event_type_invalid: 'Избран е невалиден тип събитие',
  scheduled_tasks_device_number_is_required: 'Изберете устройство(а), за да създадете събитие',

  /*
   * |=====================|
   * | License Error Page  |
   * |=====================|
   */
  license_error_page_access_restricted: 'Access Restricted',
  license_warning_access_hold: 'Достъпът до акаунта е преустановен',
  license_warning_access_hold_description:
    'Вашият достъп до платформата е временно преустановен поради неразрешено плащане. Насърчаваме ви да се свържете с нашата поддръжка или да се свържете с вашия назначен представител, за да ви помогне при разрешаване на този проблем.',
  license_warning_no_valid_license: 'Няма валиден лиценз',
  license_warning_no_valid_license_description:
    'Не можахме да намерим валиден лиценз, свързан с този акаунт. Моля, свържете се с вашия определен представител или се свържете с нашата поддръжка за помощ.',
  license_warning_devices_count_limit_reached: 'Максималният брой устройства е достигнат',
  license_warning_devices_count_limit_reached_description:
    'Достигнахте максималният брой устройства от лиценза,  които може да свържете към акаунта си. Ако желаете да добавите още, моля, свържете се с вашия определен представител или се свържете с нашата поддръжка за помощ.',
  license_warning_generic_title: 'Няма лиценз',
  license_warning_generic_description: 'Не можете да продължите поради проблем с лиценза.',
  error_forbidden_operation_not_allowed: 'Не е разрешено',

  /*
   * |=================|
   * | Trashbags       |
   * |=================|
   */
  trashbags_page_header: 'Чували',
  trashbags_status_new: 'Нов',
  trashbags_status_in_progress: 'В процес',
  trashbags_status_closed: 'Затворен',
  trashbags_fetch_error: 'Грешка при извличане на партиди',
  trashbags_batch_details_error: 'Грешка при извличане на детайли за партидата',
  trashbags_batch_number: 'Ролка чували',
  trashbags_batch_id: 'ID на ролка',
  trashbags_total_count: 'Общо',
  trashbags_new: 'Нов',
  trashbags_in_progress: 'В процес',
  trashbags_closed: 'Затворен',
  trashbags_id: 'ID',
  trashbags_rfid: 'RFID',
  trashbags_status: 'Статус',
  trashbags_account_number: 'Номер на партида',
  trashbags_created_date: 'Дата на създаване',
  trashbags_collection_date: 'Дата на събиране',
  trashbags_more_info_tooltip: 'Щракнете, за да видите повече информация',
  trashbags_details_title: 'Детайли за чантата',
  trashbags_type: 'Тип',
  trashbags_location: 'Местоположение',
  trashbags_open_in_maps: 'Отвори в Google Maps',
  trashbags_empty_title: 'Няма намерени ролки за чували',
  trashbags_empty_description: 'Все още няма ролки за чували за показване.',
  trashbags_batch_empty_title: 'Няма чували в тази ролка',
  trashbags_batch_empty_description: 'Тази ролка все още не съдържа чували.',

  /*
   * |=================|
   * | Collections     |
   * |=================|
   */
  collections_page_header: 'Справка Сметосъбиране',
  collections_fetch_error: 'Грешка при извличане на данни за събиранията',
  collections_from_date: 'От дата',
  collections_to_date: 'До дата',
  collections_account_number: 'Номер на партида',
  collections_account_id: 'ID на акаунт',
  collections_count: 'Брой събирания',
  collections_volume: 'Обем на събиранията',
  collections_export_csv: 'Експортирай',
  collections_no_data_to_export: 'Няма данни за експортиране',

  /*
   * |====================|
   * | Truck Collections  |
   * |====================|
   */
  truck_collections_page_header: 'Справка събирания по камиони',
  truck_collections_fetch_error: 'Грешка при извличане на данни за събиранията по камиони',
  truck_collections_from_date: 'От дата',
  truck_collections_to_date: 'До дата',
  truck_collections_truck_name: 'Име на камион',
  truck_collections_count: 'Брой събирания',
  truck_collections_volume: 'Обем на събиранията',
  truck_collections_export_csv: 'Експортирай CSV',
  truck_collections_view_on_map: 'Виж на картата',
  truck_collections_no_data_to_export: 'Няма данни за експортиране',

  /*
   * |================================|
   * | Truck Collections by Container |
   * |================================|
   */
  truck_collections_by_container_page_header: 'Справка събирания по камиони по съдове',
  truck_collections_by_container_fetch_error:
    'Грешка при извличане на данни за събиранията по съдове',
  truck_collections_by_container_from_date: 'От дата',
  truck_collections_by_container_to_date: 'До дата',
  truck_collections_by_container_truck_number: 'Име на камион',
  truck_collections_by_container_container_number: 'Номер на съд',
  truck_collections_by_container_container_address: 'Адрес на съд',
  truck_collections_by_container_location: 'Местоположение',
  truck_collections_by_container_status: 'Статус',
  truck_collections_by_container_date: 'Дата',
  truck_collections_by_container_status_correct: 'Коректно местоположение',
  truck_collections_by_container_status_incorrect: 'Некоректно местоположение',
  truck_collections_by_container_open_in_maps: 'Отвори в Google Maps',
  truck_collections_by_container_export_csv: 'Експортирай CSV',
  truck_collections_by_container_view_on_map: 'Виж на картата',
  truck_collections_by_container_no_data_to_export: 'Няма данни за експортиране',

  /*
   * |=======================|
   * | Container Collections |
   * |=======================|
   */
  container_collections_page_header: 'Справка събирания по съдове',
  container_collections_fetch_error: 'Грешка при извличане на данни за събиранията по съдове',
  container_collections_from_date: 'От дата',
  container_collections_to_date: 'До дата',
  container_collections_container_number: 'Номер на съд',
  container_collections_container_address: 'Адрес на съд',
  container_collections_account_id: 'ID на акаунт',
  container_collections_account_number: 'Номер на партида',
  container_collections_count: 'Брой събирания',
  container_collections_volume: 'Обем на събиранията',
  container_collections_export_csv: 'Експортирай CSV',
  container_collections_no_data_to_export: 'Няма данни за експортиране',

  // Common
  close_btn: 'Затвори',

  // TanstackTable UI
  table_search_placeholder: 'Търсене…',
  table_columns: 'Колони',
  table_toggle_all: 'Превключи всички',
  table_filter: 'Филтър',
  table_clear_filter: 'Изчисти филтъра',
  table_pin_left: 'Закачи вляво',
  table_pin_right: 'Закачи вдясно',
  table_unpin: 'Откачи',
  table_group_by_column: 'Групирай по тази колона',
  table_ungroup: 'Разгрупирай',
  table_filter_all: 'Всички',
  table_no_values: 'Няма стойности',
  table_min: 'Мин',
  table_max: 'Макс',
  table_equals: 'Равно на',
  table_from: 'От',
  table_to: 'До',
  table_yes: 'Да',
  table_no: 'Не',
  table_filter_placeholder: 'Филтриране…',
  table_density_compact: 'Компактен',
  table_density_standard: 'Стандартен',
  table_density_comfortable: 'Широк',
  table_auto_page_size: 'Авто ({rows})',
};

export default bg;
